import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const includes = ['7 kompletnych tomów', '3 bonusy dla nauczyciela', '568 stron gotowych do wydruku', 'Materiały po polsku', 'Dostęp cyfrowy zaraz po zakupie', 'Jednorazowa płatność: 17 USD'];
export function ClosingBlock() {
  return <section className="w-full bg-navy px-5 py-16 sm:py-24" data-id="element-128" data-mp="25sqktg0eodn7">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-129" data-mp="20skz0ggthld1">
        <h2 className="font-display text-2xl font-bold leading-tight text-white sm:text-4xl" data-id="element-130" data-mp="1n1prb7i21ab1">
          Mniej szukania. Więcej jasnych lekcji. Chemia gotowa wtedy, kiedy jej potrzebujesz.
        </h2>
        <p className="mt-4 text-lg font-medium text-white/70 sm:text-xl" data-id="element-131" data-mp="1d2icefvo97lt">
          Wizualna Chemia™ | Edycja 2026
        </p>

        <ul className="mt-9 grid w-full max-w-md gap-3 text-left" data-id="element-132" data-mp="3nrld83w33qs9">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-133" data-mp="3sm95mdu7l5c4">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-white/10 text-white" data-id="element-134" data-mp="3dwl2d72gvwlr">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-135" data-mp="3is8sboorwtsb" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-136" data-mp="afb8kuuk00y4">{item}</span>
            </li>)}
        </ul>

        <div className="mt-10 w-full max-w-md" data-id="element-137" data-mp="fbjtkovfmod7">
          <CTAButton label="Rozpocznij z Wizualną Chemią™" data-id="element-138" data-mp="h588hoeb2vd" />
          <p className="mt-3 text-center text-xs text-white/60" data-id="element-139" data-mp="iq72jhqt7z1">
            Bez abonamentu • Dostęp cyfrowy od razu
          </p>
        </div>
      </motion.div>
    </section>;
}